import OapBeautyGeniusWrapper from './code/Scripts/components/OapBeautyGeniusWrapper.vue';

export default {
  components: {
    OapBeautyGeniusWrapper,
  },
};
